import { isTestEnvironment } from "../utils/app";

export const MAPBOX_ACCESS_TOKEN =
    'pk.eyJ1IjoiaGVsbG90cmFja3MiLCJhIjoiY2' + (!isTestEnvironment()
            ? "xmZm1zY3FnM2VoejN6bzRmOGNwYWhucSJ9._MPdOGzWOtcUYJwMEIhYjw"
            : 'swZmZxa3RjMDEwbTNtbXR5am53Zjh5MiJ9.GzersJJhrPg4zmPe-UTj8Q'
    );

const GOOGLE_MAP_ID = "4d0afa4d861a9e1f";
const GOOGLE_MUTED_MAP_ID = "b00fdf6dc47d7096";
// not in use yet: map ID 7cdf5de276a871ff82d15afe has the calm road style ("Hellotracks calm", docs/map-styles)

const KEY_ROADMAP = 'Map.Roadmap';
const KEY_ROADMUTED = 'Map.Road.Muted';
const KEY_SATELLITE= 'Map.Satellite';
const KEY_SATELLITE_MUTED = 'Map.Satellite.Muted';
const KEY_DARKMAP = 'Map.Darkmap';
const KEY_DARKMUTED = 'Map.Clean';

export const DEFAULT_MAP = KEY_ROADMAP;

export const ROAD_MAP_OBJ = {
    labelKey: KEY_ROADMAP,
    url: 'mapbox://styles/hellotracks/clz3qhiay00mq01pfepxtcq9x',
    img: 'images/db-roadmap.png',
    googleMapId: GOOGLE_MAP_ID,
    googleMapTypeId: "roadmap",
    isDark: false,
    isMuted: false,
    toggleMuted: KEY_ROADMUTED,
};

export const ROAD_MUTED_OBJ = {
    labelKey: KEY_ROADMUTED,
    url: 'mapbox://styles/hellotracks/cljfekxli008301qs54if596e',
    img: 'images/db-lightmap.png',
    googleMapId: GOOGLE_MUTED_MAP_ID,
    googleMapTypeId: "roadmap",
    isDark: false,
    isMuted: true,
    toggleMuted: KEY_ROADMAP,
};

const SATELLITE_MAP_OBJ = {
    labelKey: KEY_SATELLITE,
    url: 'mapbox://styles/hellotracks/cldptf6ef004e01tccrg8kt6d',
    img: 'images/db-satellite.png',
    googleMapId: GOOGLE_MAP_ID,
    googleMapTypeId: "hybrid",
    isDark: false,
    isMuted: false,
    toggleMuted: KEY_SATELLITE_MUTED,
};

const SATELLITE_MUTED_OBJ = {
    labelKey: KEY_SATELLITE_MUTED,
    url: 'mapbox://styles/hellotracks/cldptf6ef004e01tccrg8kt6d',
    img: 'images/db-satellite.png',
    googleMapId: GOOGLE_MAP_ID,
    googleMapTypeId: "satellite",
    isDark: false,
    isMuted: true,
    toggleMuted: KEY_SATELLITE,
};

const DARK_MAP_OBJ = {
    labelKey: KEY_DARKMAP,
    url: 'mapbox://styles/hellotracks/cldptaz3s005601p4x0k6rr1u',
    img: 'images/db-darkmap.png',
    googleMapId: GOOGLE_MAP_ID,
    googleMapTypeId: "roadmap",
    isDark: true,
    isMuted: false,
    toggleMuted: KEY_DARKMUTED,
};

const DARK_MUTED_OBJ = {
    labelKey: KEY_DARKMUTED,
    url: 'mapbox://styles/hellotracks/cl02hjd98001v14k9i1he3s14',
    img: 'images/db-quiet.png',
    googleMapId: GOOGLE_MUTED_MAP_ID,
    googleMapTypeId: "roadmap",
    isDark: true,
    isMuted: true,
    toggleMuted: KEY_DARKMAP,
};

export const HEAT_MAP_OBJ = {
    labelKey: 'Map.Heatmap',
    url: DARK_MUTED_OBJ.url,
    img: '',
    googleMapId: DARK_MUTED_OBJ.googleMapId,
    googleMapTypeId: DARK_MUTED_OBJ.googleMapTypeId,
    isDark: true,
    isMuted: true,
    toggleMuted: KEY_DARKMAP,
};

export const MAP_TYPES_OBJ: {
    [key: string]: {
        labelKey: string;
        url: string;
        img: string;
        googleMapId: string | undefined;
        googleMapTypeId: string;
        isDark: boolean;
        isMuted: boolean;
        toggleMuted: string;
    };
} = {
    [KEY_ROADMAP]: ROAD_MAP_OBJ,
    [KEY_ROADMUTED]: ROAD_MUTED_OBJ,
    [KEY_SATELLITE]: SATELLITE_MAP_OBJ,
    [KEY_SATELLITE_MUTED]: SATELLITE_MUTED_OBJ,
    [KEY_DARKMAP]: DARK_MAP_OBJ,
    [KEY_DARKMUTED]: DARK_MUTED_OBJ,
};


export const MAP_TYPES = Object.entries(MAP_TYPES_OBJ).map(([key, value]) => ({
    mapType: key,
    ...value,
}));
